import gql from 'graphql-tag';



export const GET_LISTA_USUARIOS = gql(`
   query listaUsuarios($filter: [String], $sort: [String], $page: Int!, $size: Int!,$idioma: String) {
      listaUsuarios(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
         totalElements
         firstElement
         results {
            id
            nombre
            apellidos
            idLegal
            fechaAlta     
            clienteIdLegal     
            literalTipoUsuarioDetalle(idioma: $idioma){
                clave
                valor
            } 
            literalTipoSociedadDetalle(idioma: $idioma){
                clave
                valor
            }          
         }
      }
   }
`)

export const GET_USUARIO_BY_ID = gql(`
    query getUsuario($idUsuario: Long, $idioma: String) {
        getUsuario(idUsuario: $idUsuario) {
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            cnae
            iban
            tipoSociedad    
            fechaAlta
            razonSocial
            fechaAlta      
            literalTipoUsuarioDetalle(idioma: $idioma){
                clave
                valor
            }
            literalTipoSociedadDetalle(idioma: $idioma){
                clave
                valor
            }
            clienteIdLegal
        }
    }
`);


export const GET_USUARIO_BY_UUID = gql(`
    query getUsuarioUuid($uuidUsuario: UUID, $idioma: String) {
        getUsuarioUuid(uuid: $uuidUsuario) {
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            cnae
            iban
            tipoSociedad    
            fechaAlta
            razonSocial
            fechaAlta    
            genero
            cartera{
                totalElements
                results {
                    cartera {
                        id
                        nombre
                        descripcion
                        referenciaCliente
                        operativa
                        idPadre
                        cliente {
                            idLegal
                            nombre
                            apellidos
                        }
                        usuarioCliente {
                            uuid
                            idLegal
                            nombre
                            apellidos
                        }
                        acreedor {
                            uuid
                            idLegal
                            nombre
                            razonSocial
                            apellidos
                        }
                        segmento {
                            id
                            nombre
                            activo
                        }
                        acreedorPorDefecto
                        acreedorObligatorio
                        iban
                        diasLimiteImpagos
                        diasLimiteIncidencias
                        fechaActualizacion 
                    }
                }
            }
            commercialCommunications
            literalTipoUsuarioDetalle(idioma: $idioma){
                clave
                valor
            }
            literalTipoSociedadDetalle(idioma: $idioma){
                clave
                valor
            }
            clienteIdLegal
            clienteUuid
            cliente{
                id
               contactosActivos{
                  email {
                        valor {
                           email 
                        }
                  }
                  telefono {
                        valor {
                           telefono
                        }
                  }
                  direccion {
                        valor {
                           tipoDireccion
                           direccion
                           localidad
                           provincia
                           pais
                           codigoPostal
                        }
                  }
               }
            }
            promotor{
               codigoPromotor
            }
            esMayorista
            contactosActivos {
                email {
                    valor {
                        email 
                    }
                }
                telefono {
                    valor {
                        telefono
                    }
                }
                direccion {
                    valor {
                        tipoDireccion
                        direccion
                        localidad
                        provincia
                        pais
                        codigoPostal
                    }
                }
            }
        }
    }
`);

export const GET_USUARIOS_BY_ID_CLIENTE = gql(`
    query getUsuariosByIdCliente ($idCliente: String, $idioma: String) {
        getUsuariosByIdCliente(idCliente: $idCliente) {
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            tipoSociedad
            cnae
            iban
            razonSocial
            fechaAlta 
            commercialCommunications
            literalTipoUsuarioDetalle(idioma: $idioma){
                clave
                valor
            }
            literalTipoSociedadDetalle(idioma: $idioma){
                clave
                valor
            }
        }
    }
`);

export const MODIFICA_USUARIO = gql(`
    mutation modificarUsuario ($modificarUsuarioRequest: ModificarUsuarioRequestInput, $idioma: String) {
        modificarUsuario(modificarUsuarioRequest: $modificarUsuarioRequest) {
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            tipoSociedad
            cnae
            iban
            razonSocial
            fechaAlta 
            commercialCommunications
            literalTipoUsuarioDetalle(idioma: $idioma){
                clave
                valor
            }
            literalTipoSociedadDetalle(idioma: $idioma){
                clave
                valor
            }
        }
    }
`);

export const MODIFICA_USUARIO_TOS = gql(`
    mutation modificarUsuarioTos($query: ModificarUsuarioTosRequestInput) {
        modificarUsuarioTos(modificarUsuarioTosRequest: $query){
            uuid
            tos
        }
    }
`);

export const ALTA_USUARIO = gql(`
    mutation altaUsuario ($altaUsuarioRequest: AltaUsuarioRequestInput) {
        altaUsuario(altaUsuarioRequest: $altaUsuarioRequest) {
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            tipoSociedad
            cnae
            iban
            razonSocial
            fechaAlta 
        }
    }
`);

export const BORRAR_USUARIO = gql(`
    mutation borrarUsuario( $uuid: UUID){
        borrarUsuario(uuid: $uuid){
            id
            uuid
            nombre
            apellidos
            idLegal
            tipo
            tipoSociedad
            cnae
            iban
            razonSocial
            fechaAlta 
        }
    }
`);

export const GET_LISTADO_TIPOS_USUARIO_TIPOS_SOCIEDAD = gql(`
    query listadoTipos($idioma: String) {
        listadoTiposUsuario(idioma: $idioma) {
            codigo
            clave
            valor 
            idioma     
        }
        listadoTiposSociedad(idioma: $idioma) {
            codigo
            clave
            valor 
            idioma     
        }
    }
`);


export const QUERY_LISTADO_AGENTES =  gql(`
    query listadoLiterales{
        agents:listaAgentes  {
            id
            uuid
            nombre
            apellidos
        }
    }`)

export const LISTADO_NOTARIOS = `listaNotarios {
    id
    uuid
    nombre
    apellidos
}`;    

export const QUERY_LISTADO_NOTARIOS =  gql(`
    query listadoNotarios {
        ` + LISTADO_NOTARIOS + `
    }`
);    

export const QUERY_AGRUPACION_CONTEO_USUARIOS = gql(`
    query agrupacionConteosPorUsuario($filter: [String], $page: Int!, $size: Int!, $groupField1: String!, $groupField2: String!){
        tiposUsuarios:agrupacionUsuarios(criteria: { filter: $filter, page: $page, size: $size}, groupField: $groupField1) {
            groupCount
            totalCount
            groupList {
                group 
                count         
            }
        }
        tiposSociedades:agrupacionUsuarios(criteria: { filter: $filter, page: $page, size: $size}, groupField: $groupField2) {
            groupCount
            totalCount
            groupList {
                group 
                count         
            }
        }
    }`)

export const QUERY_CONTEO_USUARIOS = gql(`
    query conteos($filter: [String], $page: Int!, $size: Int!){
       conteoUsuarios(criteria: { filter: $filter, page: $page, size: $size})
    }`)    

export const CAMBIAR_EMAIL_USUARIO = gql(`
   mutation cambioEmailUsuario($oldEmailUsuario: String, $nuevoEmailUsuario: String) {
      cambioEmailUsuario(oldEmail: $oldEmailUsuario, nuevoEmail: $nuevoEmailUsuario){
         nuevoEmail
      }
   }`)
export const ENVIAR_RESET_PASSWORD = gql(`
   query envioResetPassword($userEmail: String){
      envioResetPassword(userEmail: $userEmail){
         envioReset
      }
   }`)

export const ASIGNAR_AVATAR = gql(`
    mutation asignarAvatar ($modificarUsuarioRequest: ModificarUsuarioRequestInput) {
        asignarAvatar(modificarUsuarioRequest: $modificarUsuarioRequest) {
            id
            uuid
            genero
        }
    }
`);


export const MUTATION_MODIFY_COMMERCIAL_COMMUNICATIONS = gql(`
    mutation modificarComunicacionesComerciales ($modificarUsuarioRequest: ModificarUsuarioRequestInput) {
        modificarComunicacionesComerciales(modificarUsuarioRequest: $modificarUsuarioRequest) {
            id
            uuid
            commercialCommunications
        }
    }
`);

export const GET_LISTA_USUARIOS_VIEW = gql(`
   query listaUsuariosView($filter: [String], $sort: [String], $page: Int!, $size: Int!) {
    listaUsuariosView(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
         totalElements
         firstElement
         results {
            id
            fechaAlta
            nombre
            apellidos
            idLegal
            tipo           
            tipoSociedad    
            clienteIdLegal
            idLegalPromotor
            email   
            razonSocial             
         }
      }
   }
`)